import * as React from 'react'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'

export const BannerDistributionChart: React.FunctionComponent = ({ }) => {
    const [total, setTotal] = React.useState(0)
    return (
        <BPMChart title='Banner Distribution' subTitle='By Clicks' type='tree'
            onRequestLoad={(options, signal) => {
                return BPMAnalyticsAPI.get<any>('browse/banner-distribution', options, signal).then((d) => {
                    setTotal(d.reduce((a, b) => a + b.count, 0))
                    return d
                })
            }} series={{ valueField: 'count', argumentField: 'image_url', name: 'Banner' }}
            chartProps={{
                onNodesRendering: function (e) {
                    if (!e.node) {
                        return
                    }
                    var nodes = e.node.getAllChildren()
                    for (var i = 0; i < nodes.length; i++) {
                        var node = nodes[i];
                        node.label(`${node.data.count} Clicks (${(100 / total * node.data.count).toFixed(1)}%)`)
                    }
                }
            }}
            customizeToolTip={(e, dataSource) => {
                return { html: `<img src=${e.node.data.image_url} width="${400}" />` }
            }}>
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Browse/charts/BannerDistribuionChart.tsx